import React from 'react';
import { PaperStack } from 'src/design/atoms/PaperStack';
import { Title } from 'src/design/atoms/Title';
import {
  IWorkflowRecordFieldsProps,
  WorkflowRecordFieldErrors,
  WorkflowRecordFields,
} from 'src/app/workflows/WorkflowRecordFields';

export type WorkflowRecordFieldName = keyof WorkflowRecordFieldErrors;

export interface IWorkflowRecordSectionProps
  extends Omit<IWorkflowRecordFieldsProps, 'fieldErrors'> {
  /** Heading above the field block, e.g. "Drawing". */
  sectionTitle: string;
  fieldError: (field: WorkflowRecordFieldName) => React.ReactNode;
}

/**
 * @registry The titled record panel of a workflow form (Drawing, Submittal): a PaperStack
 * heading plus WorkflowRecordFields. Owns the mapping from the form's fieldError accessor
 * to the field-error keys WorkflowRecordFields renders, so callers pass the accessor itself.
 */
export const WorkflowRecordSection: React.FC<IWorkflowRecordSectionProps> = ({
  sectionTitle,
  fieldError,
  ...fields
}) => (
  <PaperStack>
    <Title order={4}>{sectionTitle}</Title>
    <WorkflowRecordFields
      {...fields}
      fieldErrors={{
        title: fieldError('title'),
        assigneeUserId: fieldError('assigneeUserId'),
        company: fieldError('company'),
        intentOfReview: fieldError('intentOfReview'),
        milestonePhaseItemId: fieldError('milestonePhaseItemId'),
      }}
    />
  </PaperStack>
);
